import React, { useEffect, useState } from "react";
import axios from "axios";

function History() {
  const [history, setHistory] = useState([]);
  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (role === "superadmin") {
      fetchHistory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchHistory = async () => {
    try {
      const res = await axios.get("https://hrpsc.swisstekaluminium.com/api/history", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setHistory(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.log(error);
      alert("Failed to load history");
    }
  };

  const downloadCSV = () => {
    if (history.length === 0) {
      alert("No history data to download");
      return;
    }
    const headers = [
      "Date",
      "Module",
      "Action",
      "Description",
      "User",
      "Role",
    ];
    const rows = history.map((item) => [
      new Date(item.createdAt).toLocaleString(),
      item.module,
      item.action,
      item.description,
      item.username,
      item.role,
    ]);
    const csvContent = [
      headers.join(","),
      ...rows.map((row) =>
        row
          .map((value) =>
            `"${String(value || "").replace(/"/g, '""')}"`
          )
          .join(",")
      ),
    ].join("\n");
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "app_history_report.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  // Only Super Admin can view App History.
  // (Backend already enforces this on the route - this is just UI-level.)
  if (role !== "superadmin") {
    return (
      <div className="page-container">
        <h1 className="page-title">Access Denied</h1>
        <p>You don't have permission to view this page.</p>
      </div>
    );
  }

  return (
    <div className="page-container">
      <h1 className="page-title">App History</h1>
      <button
        className="add-btn"
        onClick={downloadCSV}
        style={{ marginBottom: "20px" }}
      >
        Download History Report
      </button>
      <table className="custom-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Module</th>
            <th>Action</th>
            <th>Description</th>
            <th>User</th>
            <th>Role</th>
          </tr>
        </thead>
        <tbody>
          {history.length > 0 ? (
            history.map((item) => (
              <tr key={item._id}>
                <td>{new Date(item.createdAt).toLocaleString()}</td>
                <td>{item.module}</td>
                <td>{item.action}</td>
                <td>{item.description}</td>
                <td>{item.username}</td>
                <td>{item.role}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="6"
                style={{
                  textAlign: "center",
                  padding: "30px",
                  color: "gray",
                }}
              >
                No History Records Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
export default History;